import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {UserDto} from "../../models/admin_owner/user/user-dto";
import {AuthenticationService} from "../../_auth/authentication.service";
import {ServerEndpoints} from "../../server.endpoints";

@Injectable({
  providedIn: 'root'
})
export class UserHttpService {

  constructor(private httpClient: HttpClient, @Inject("BASE_URL") private baseUrl: string, private authenticationService: AuthenticationService) {
  }

  list(): Observable<UserDto[]> {
    return this.httpClient.get<UserDto[]>(this.baseUrl + ServerEndpoints.Administration_User_List);
  }

  get(id: string): Observable<UserDto> {
    return this.httpClient.get<UserDto>(this.baseUrl + ServerEndpoints.Administration_User_Get + "?id=" + id);
  }

  /**
   * Creates a login user on the caller's own shard.
   *
   * `admin` and `operator` are the **meta-role creation flags**: the legacy meta roles are filtered out of the
   * role/permission screens, so a baseline role can only ever be handed out here, at creation time. `operator`
   * grants the standalone, read-only Operator ("Betriebsleitung") baseline — the live service screens and
   * nothing else. It is held *instead of* Admin, not alongside it.
   */
  add(name: string, password: string, admin: boolean = false, operator: boolean = false,
      login: boolean = false): Observable<UserDto> {
    return this.httpClient.post<UserDto>(this.baseUrl + ServerEndpoints.Administration_User_Add, {
      "Name": name,
      "Password": password,
      "Admin": admin,
      "Operator": operator,
      "Login": login,
      "Shard": this.authenticationService.userValue?.shard.id,
      "Company": this.authenticationService.userValue?.company.id
    });
  }

  delete(id: string) {
    return this.httpClient.delete(this.baseUrl + ServerEndpoints.Administration_User_Delete + "?id=" + id);
  }
}
